import { render, staticRenderFns } from "./UploadFileContract2023.vue?vue&type=template&id=95b1372a&scoped=true"
import script from "./UploadFileContract2023.vue?vue&type=script&lang=js"
export * from "./UploadFileContract2023.vue?vue&type=script&lang=js"
import style0 from "./UploadFileContract2023.vue?vue&type=style&index=0&id=95b1372a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b1372a",
  null
  
)

export default component.exports